export const MODAL_DIALOG_TOGGLE = 'MODAL_DIALOG_TOGGLE';
export const MODAL_DIALOG_SET_TOGGLE = 'MODAL_DIALOG_SET_TOGGLE';
export const MODAL_DIALOG_SET_MODAL_BODY = 'MODAL_DIALOG_SET_MODAL_BODY';
